import AboutHero from "./components/AboutHero";
import StorySection from "./components/StorySection";
import WhatWeDoSection from "./components/WhatWeDoSection";
import ValuesSection from "./components/ValuesSection";
import GovernanceTeaser from "./components/GovernanceTeaser";

export default function About() {
  return (
    <main className="min-h-screen">
      <AboutHero />
      <StorySection />
      <WhatWeDoSection />
      <ValuesSection />
      <GovernanceTeaser />
    </main>
  );
}